import type { ReactNode } from 'react';
import { useEscape } from './useEscape';

/**
 * Shared modal shell for the cart step (save-order + add-frame dialogs).
 * Esc and backdrop-click close; the card stops click propagation.
 */
export function CartModal({
  title,
  caption,
  onClose,
  children,
  width = 460,
}: {
  title: string;
  caption?: string;
  onClose: () => void;
  children: ReactNode;
  width?: number;
}) {
  useEscape(onClose);
  return (
    <div className="cmodal__backdrop" onMouseDown={onClose} role="presentation">
      <div
        className="cmodal"
        style={{ width: `min(${width}px, calc(100vw - 36px))` }}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="cmodal__head">
          <div>
            <div className="cmodal__title">{title}</div>
            {caption && <div className="cmodal__caption">{caption}</div>}
          </div>
          <button type="button" className="cmodal__x" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
